import { useUserStore } from '@/stores/user'

export async function accountLogout() {
  const userStore = useUserStore()
  await userStore.logout()

  window.location.href = '/'
}

export function navigateToLogin() {
  // routerPush('login')
  window.location.hash = '#login'
}
